import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export enum ActiveSort {
	Asc,
	Desc,
	None,
}

interface IProps {
	sortAsc: () => void
	sortDesc: () => void
	useActiveArrow?: ActiveSort
}

export default function SortingArrows({
	sortAsc,
	sortDesc,
	useActiveArrow = ActiveSort.None,
}: IProps) {
	const [activeArrow, setActiveArrow] = useState<ActiveSort>(useActiveArrow)

	const sortAscending = () => {
		setActiveArrow(ActiveSort.Asc)
		sortAsc()
	}

	const sortDescending = () => {
		setActiveArrow(ActiveSort.Desc)
		sortDesc()
	}

	useEffect(() => {
		setActiveArrow(useActiveArrow)
	}, [useActiveArrow])

	return (
		<div className="sorting-arrows pointer ml-2 d-flex flex-column">
			<FontAwesomeIcon
				onClick={() => sortAscending()}
				icon="sort-up"
				className={
					'arrow up ' +
					(activeArrow === ActiveSort.Asc ? 'active' : '')
				}
			/>
			<FontAwesomeIcon
				onClick={() => sortDescending()}
				icon="sort-down"
				className={
					'arrow down ' +
					(activeArrow === ActiveSort.Desc ? 'active' : '')
				}
			/>
		</div>
	)
}
